define(function (require, exports, module) {
    var BaseHeartbeatItem = require('./BaseHeartbeatItem');
    var MessageService = require('message-service/message-service');
    var logg = require('../../utils/core-log');
    var exists = require('extant/extant');
    var Datasources = require('../../enums/DataSourceList');
    var DatasourceToEventMap = require('../../enums/DatasourceToEventMap');
    var EventTypes = require('../../enums/DataEvents');
    var Config = require('../../utils/HeartbeatConfig');
    var TfsManager = require('../../control/TfsManager');

    var Superclass;
    var EMPTY_STRING = '';
    var TIMESTAMP_PATH = 'metaData.timeStamp';
    var WAIT_PATH = 'data.metaData.wait';
    var GAMESTATE_PATH = 'api.gameData.status.abstractGameState';
    var DIFFPATCH = '/diffPatch';

    function BaseApiHeartbeatItem (id, gameItem) {
        var that = this;
        Superclass.constructor.call(this, id, gameItem);
        this.callbacks = {
            handleDataLoad: function (result) {
                that.handleDataLoad(result);
            }
        };
    }

    BaseHeartbeatItem.spawn(BaseApiHeartbeatItem).define({
        executeHeartbeat: function () {
            var data;
            var paramOverrides = {
                differ: EMPTY_STRING
            };
            var previousTimecode;

            logg.log('GET SOME GUMBO!');

            if (this.secondHelping) {
                data = this.gameItem.getGameData();
                if (exists(data.api, TIMESTAMP_PATH)) {
                    previousTimecode = data.api.metaData.timeStamp;
                }
                if (previousTimecode) {
                    if (TfsManager.ensureTimecodeRangeIsValid(previousTimecode)) {
                        this.previousTimecode = previousTimecode;
                        paramOverrides.differ = DIFFPATCH;
                    } else {
                        this.previousTimecode = false;
                        this.secondHelping = false;
                    }
                }
            }

            Superclass.executeHeartbeat.call(this);
            this.setParams(paramOverrides);
            this.fetch(Datasources.API, true, null).then(
                this.callbacks.handleDataLoad,
                this.callbacks.handleDataLoad
            );
        },

        handleDataLoad: function (result) {
            if (!exists(result.data)) {
                MessageService.publish(EventTypes.CONNECTION_ERROR, { error: true });
                
                logg.log('There was a fatal error loading the game data');

                return;
            }

            var success = this.store(result);

            // Oh snap, bro... oh snap
            // I messed up the patch or something, bro.
            // Oh snap... I'm gonna try again bro
            if (!success) {
                this.secondHelping = false;
                // Here we go!
                // this.executeHeartbeat();
                return;
            }
            this.setGameState();
            if (!this.secondHelping) {
                this.secondHelping = true;
            }

            if (exists(result, WAIT_PATH)) {
                this.liveRefreshTimer = Config.wait = result.data.metaData.wait;
            }

            this.publishHeartbeat();
        },

        store: function (result) {
            var modelCache = this.gameItem.modelCache;
            if (result.dataSourceName === Datasources.API) {
                return modelCache.storeApiData(result);
            } else {
                modelCache.storeGameData(result);
            }
            return result;
        },

        setGameState: function () {
            var game = this.gameItem.getGameData();

            if (!exists(game, GAMESTATE_PATH)) {
                return;
            }
            this.gamestate = game.api.gameData.status.abstractGameState.toLowerCase();
        },

        start: function () {
            var heartBeatPulsed = Superclass.start.call(this);
            if (!heartBeatPulsed) {
                // This could get messy if the flags get out
                // of sync.
                this.publishHeartbeat();
            }
            return heartBeatPulsed;
        },

        publishHeartbeat: function () {
            var gameData = this.gameItem.getGameData();
            var API_STATE_EVENT = EventTypes.UPDATE;
            if (this.firstRun) {
                this.firstRun = false;
                this.initComplete = true;
                API_STATE_EVENT = EventTypes.INIT_DATA_LOADED;
            }
            // We're not active, but also not paused so switch up
            // the publish event, and mark ourselves as active.
            if (!this.active && !this.paused) {
                this.active = true;
                this.start();
                API_STATE_EVENT = EventTypes.INIT_DATA_LOADED;
            }
            MessageService.publish(API_STATE_EVENT, gameData);
            MessageService.publish(DatasourceToEventMap.API, gameData.api);
        }
    });

    Superclass = BaseApiHeartbeatItem.superclass;

    return BaseApiHeartbeatItem;
});
